import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box, Typography, Button,
} from '@material-ui/core';
import { openWhitelist } from 'actions/authDialogActions';
import notFoundSearchStyles from './styles';

const NotFoundSearch = () => {
  const classes = notFoundSearchStyles();
  const dispatch = useDispatch();

  const handleWhitelist = e => {
    e.preventDefault();
    dispatch(openWhitelist());
  };

  return (
    <Box className={classes.block}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="inherit"
        // minHeight="300px"
      >
        <Box display="flex" justifyContent="center" textAlign="center" mb={2}>
          <Typography variant="subtitle2" className={classes.textHint}>
            We didn’t find any available preceptor. Join our waitlist and
            we’ll notify you when new preceptors become available.
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <Button variant="contained" color="primary" onClick={handleWhitelist}>
            Join waitlist
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NotFoundSearch;
